"use client";

import { useEffect, useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Button } from "@/components/ui/Button";

interface ShareButtonProps {
  className?: string;
}

export const ShareButton = ({ className }: ShareButtonProps) => {
  const [url, setUrl] = useState("");
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    setUrl(window.location.href);
  }, []);

  useEffect(() => {
    if (!copied) return;
    const timer = setTimeout(() => setCopied(false), 2000);
    return () => clearTimeout(timer);
  }, [copied]);

  return (
    <CopyToClipboard text={url} onCopy={() => setCopied(true)}>
      <Button
        variant="outline"
        color="primary"
        size="small"
        className={className}
      >
        {copied ? "Copied" : "Share"}
      </Button>
    </CopyToClipboard>
  );
};
